const user = {
  isUserAuthenticated: false,
  user: '',
  Is3PL: false,
  Is3PLMEL: false,
  Is3PLSYD: false,
  Is3PLCAI: false,
  Is3PLADE: false,
  Is3PLBRIS: false,
  DefaultLocationForSupplier: '',
  FirstName: '',
  Company: '',
  base_group: '',
  key: '',
  externalID: '',
  warehouseCode: '',
  parentID: null,
  details: {
    SavedCreditCard: {
      ID: 0,
    },

    // TODO: Remove the old one (below)
    defaultCreditCardID: 0,
    defaultDeliveryAddressID: 0,
    state: '',
  },
  childetails: {},
  HideFreightIncreaseNotification: true,
  isWholesaler: true,
  isSuperWholesaler: false,
  isSubWholesaler: false,
  isSupplier: false,
  customerID: 0,
  cartItemCount: 0,
  customerPromo: {},
  notifyRestockViaSMS: false,
  notifyRestockViaEmail: false,
  discountSyncing: false,
  discountSyncingInProcess: false,
  priceSync: false,
  HidePopup: false,
  loadingEmail: false,
  loadingSMS: false,
  loadingBackorderSMS: false,
  calculatedTotalLoyaltyPoints: 0,
  calculatedCurrentLoyaltyPoints: 0,
  categoryFilters: {},
  globalConfig: {
    checkoutPaymentMethods: null,
    invoicePaymentMethods: null,
    useCurrentCards: null,
    productBrands: [],
    productCategory: [],
    productTypes: [],
    productVarietals: [],
    productStyles: [],
    threePLLocations: {},
    categoryTopFilters: [],
    threePlCreditTerms: [],
    enableCPI: false,
    hideBackOrderSuppliers: null,
  },
  hasActiveFilters: false,
  consolidationDay: {
    isConsolidationEnabled: false,
    day: '',
    date: '',
    deliveryDates: [],
  },
  isLoading: {
    updateMember: false,
  },
  showLoyaltyModal: false,
}

const UserReducer = function (state = user, action) {
  switch (action.type) {
    case 'SET_USER_CREDENTIALS': {
      const {
        user,
        base_group,
        key,
        externalID,
        superWholesalerID,
        parentID,
        defaultDeliveryAddressID,
        defaultSavedCreditCardID,
        isSuperWholesaler,
        isSubWholesaler,
        isSupplier,
        supplierID,
        customerID,
        discountSyncingInProcess,
        cartItemCount,
        customerPromo,
        promoDeals,
        discountSyncing,
        calculatedTotalLoyaltyPoints,
        calculatedCurrentLoyaltyPoints,
        FirstName,
        Company,
        HideFreightIncreaseNotification,
        HideQLDCustomerPopup,
        Is3PL,
        Is3PLMEL,
        Is3PLSYD,
        Is3PLCAI,
        Is3PLADE,
        Is3PLBRIS,
        DefaultLocationForSupplier,
        ChargeArea,
        EnLocationID,
      } = action.params

      let newUser = {}

      if (user) newUser.user = user
      if (Is3PL) newUser.Is3PL = Is3PL
      if (Is3PLMEL) newUser.Is3PLMEL = Is3PLMEL
      if (Is3PLSYD) newUser.Is3PLSYD = Is3PLSYD
      if (Is3PLCAI) newUser.Is3PLCAI = Is3PLCAI
      if (Is3PLADE) newUser.Is3PLADE = Is3PLADE
      if (Is3PLBRIS) newUser.Is3PLBRIS = Is3PLBRIS
      if (ChargeArea) newUser.chargeArea = ChargeArea
      if (EnLocationID) newUser.enLocationID = EnLocationID
      if (DefaultLocationForSupplier) newUser.DefaultLocationForSupplier = DefaultLocationForSupplier
      if (base_group) newUser.base_group = base_group
      if (key) newUser.key = key
      if (externalID) newUser.externalID = externalID
      if (FirstName) newUser.FirstName = FirstName
      if (Company) newUser.Company = Company
      if (HideFreightIncreaseNotification !== undefined)
        newUser.HideFreightIncreaseNotification = HideFreightIncreaseNotification
      if (superWholesalerID) newUser.superWholesalerID = superWholesalerID
      if (parentID) newUser.parentID = parentID
      if (defaultDeliveryAddressID) newUser.defaultDeliveryAddressID = defaultDeliveryAddressID
      if (defaultSavedCreditCardID) newUser.defaultSavedCreditCardID = defaultSavedCreditCardID
      if (isSuperWholesaler) {
        newUser.isSuperWholesaler = isSuperWholesaler
        newUser.isWholesaler = false
      }
      if (isSubWholesaler) {
        newUser.isSubWholesaler = isSubWholesaler
        newUser.isWholesaler = false
        // defaultSavedCreditCardID =
      }

      if (isSupplier) {
        newUser.isSuperWholesaler = isSuperWholesaler
        newUser.isWholesaler = false
        newUser.supplierID = supplierID
      }

      if (customerID) {
        newUser.customerID = customerID
      }

      if (HideQLDCustomerPopup !== undefined) newUser.HideQLDCustomerPopup = HideQLDCustomerPopup
      if (cartItemCount >= 0) newUser.cartItemCount = cartItemCount
      if (customerPromo) newUser.customerPromo = customerPromo
      if (promoDeals) newUser.promoDeals = promoDeals
      if (discountSyncing) newUser.discountSyncing = discountSyncing
      if (discountSyncingInProcess) newUser.discountSyncingInProcess = discountSyncingInProcess
      if (typeof calculatedTotalLoyaltyPoints !== 'undefined')
        newUser.calculatedTotalLoyaltyPoints = calculatedTotalLoyaltyPoints
      if (typeof calculatedCurrentLoyaltyPoints !== 'undefined')
        newUser.calculatedCurrentLoyaltyPoints = calculatedCurrentLoyaltyPoints

      return {
        ...state,
        ...newUser,
        isUserAuthenticated: true,
      }
    }
    case 'SET_CONSOLIDATION_DAY': {
      return {
        ...state,
        consolidationDay: action.params,
      }
    }
    case 'CLEAR_CONSOLIDATION_DAY': {
      return {
        ...state,
        consolidationDay: user.consolidationDay,
      }
    }
    case 'UPDATE_USER': {
      return {
        ...state,
        [action.target]: action.value,
      }
    }
    case 'UPDATE_USER_DETAIL': {
      let updatedState = {
        ...state,
        details: {
          ...state.details,
          [action.target]: action.value,
        },
      }

      return updatedState
    }
    case 'UPDATE_USER_DETAILS': {
      let updatedState = {
        ...state,
        details: {
          ...state.details,
          ...action.details,
        },
      }

      return updatedState
    }
    case 'UPDATE_CHILD_USER_DETAILS':
      return {
        ...state,
        childetails: action.childetails,
      }
    // case 'UPDATE_CHILD_USER_DETAILS': {
    //   let updatedState = {
    //     ...state,
    //     childetails: {
    //       ...state.childetails,
    //       ...action.childetails,
    //     },
    //   }

    //   return updatedState
    // }
    case 'DELETE_CHILD_USER_DETAILS': {
      console.log('Reducer - DELETE_CHILD_USER_DETAILS action received:', action.id)
      const newChildDetails = Object.values(state.childetails).filter((child) => child.ID !== action.id)
      console.log('Reducer - newChildDetails after deletion:', newChildDetails)
      return {
        ...state,
        childetails: newChildDetails,
      }
    }
    case 'NOTIFY_RESTOCK_EMAIL': {
      return {
        ...state,
        notifyRestockViaEmail: action.value,
      }
    }
    case 'NOTIFY_RESTOCK_SMS': {
      return {
        ...state,
        notifyRestockViaSMS: action.value,
      }
    }
    case 'TOGGLE_NOTIFY_RESTOCK_EMAIL_LOADING': {
      return {
        ...state,
        loadingEmail: action.value,
      }
    }
    case 'TOGGLE_NOTIFY_RESTOCK_SMS_LOADING': {
      return {
        ...state,
        loadingSMS: action.value,
      }
    }
    case 'TOGGLE_BACKORDER_SMS_LOADING': {
      return {
        ...state,
        loadingBackorderSMS: action.value,
      }
    }
    case 'SET_GLOBAL_CONFIG': {
      const {
        CategoryTopFilters,
        CheckoutPaymentMethods,
        InvoicePaymentMethods,
        UseCurrentCards,
        ProductTypes,
        ProductVarietals,
        ProductBrands,
        ProductCategory,
        ProductStyles,
        ThreePLLocations,
        EnableCPI,
        HideBackOrderSuppliers,
      } = action.value

      return {
        ...state,
        globalConfig: {
          checkoutPaymentMethods: CheckoutPaymentMethods,
          invoicePaymentMethods: InvoicePaymentMethods,
          categoryTopFilters: CategoryTopFilters,
          useCurrentCards: UseCurrentCards,
          productBrands: ProductBrands?.flat(),
          productCategory: ProductCategory,
          productTypes: ProductTypes?.split(','),
          productVarietals: ProductVarietals?.split(','),
          productStyles: ProductStyles?.split(','),
          threePLLocations: JSON.parse(ThreePLLocations),
          enableCPI: EnableCPI,
          hideBackOrderSuppliers: HideBackOrderSuppliers,
        },
      }
    }

    case 'SET_GLOBAL_CONFIG_FILTERS': {
      return {
        ...state,
        categoryFilters: action.value,
      }
    }

    case 'TOGGLE_GLOBAL_CONFIG_FILTERS': {
      return {
        ...state,
        categoryFilters: action.value,
      }
    }

    case 'TOGGLE_ACTIVE_GLOBAL_CONFIG_FILTERS': {
      return {
        ...state,
        hasActiveFilters: action.value,
      }
    }

    case 'TOGGLE_UPDATE_MEMBER_LOADING': {
      return {
        ...state,
        isLoading: {
          updateMember: action.value,
        },
      }
    }
    case 'SET_DISCOUNT_SYNCING': {
      return {
        ...state,
        discountSyncing: action.value,
      }
    }
    case 'SET_GOLBAL_CONFIG_CREDIT_TERMS': {
      return {
        ...state,
        globalConfig: {
          ...state.globalConfig,
          threePlCreditTerms: action.value,
        },
      }
    }
    case 'SET_DISCOUNT_SYNCING_INPROCESS': {
      return {
        ...state,
        discountSyncingInProcess: action.value,
      }
    }
    case 'SET_DISCOUNT_SYNC': {
      return {
        ...state,
        priceSync: action.value,
      }
    }
    default: {
      return state
    }
  }
}

export default UserReducer
